import React, {FC} from "react";
import GridShape from "../components/common/GridShape";
import { Link } from "react-router";

const AuthLayout:FC<{children: React.ReactNode}> = ({ children}) => {
  return (
    <div className="relative p-6 bg-white z-1 sm:p-0">
      <div className="relative flex flex-col justify-center w-full h-screen lg:flex-row sm:p-0">
        {children}
        <div className="items-center hidden w-full h-full lg:w-1/2 bg-gray-800 lg:grid">
          <div className="relative flex items-center justify-center z-1">

            <GridShape />
            <div className="flex flex-col items-center max-w-xs">
              <Link to="/" className="block">
                <img
                  width={231}
                  height={48}
                  src="https://kmcwebsite.nyc3.cdn.digitaloceanspaces.com/assets/images/logo.png"
                  alt="Logo"
                />
              </Link>
              <p className="text-center text-gray-400 ">
                Kiira Integrated Information Systems
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AuthLayout;
